export const generateSearchParams = (params: object) => {
  return new URLSearchParams(
    Object.entries(params)
      .filter(([_, v]) => v !== undefined)
      .map(([key, value]) => [key, String(value)]),
  );
};
